import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';

const AboutPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative min-h-screen bg-[#f5f3f0]">
      <Navbar textColor="green" logoVariant="green" hoverColor="copper" />

      <main className="relative z-10 min-h-screen px-6 py-32 md:py-40 lg:px-16">
        <div
          className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Top Section - Centered */}
          <div className="mb-16 flex flex-col items-center max-w-5xl mx-auto">
            <h1
              className="text-[#e4a483] text-xs md:text-sm tracking-[0.4em] font-medium uppercase mb-4"
              style={{ fontFamily: "'Figtree', sans-serif" }}
            >
              About the Society
            </h1>

            <p
              className="text-[#1a441f] text-3xl md:text-5xl lg:text-6xl leading-tight font-light italic border-l-4 border-[#e4a483] pl-8 lg:pl-12 max-w-2xl"
              style={{ fontFamily: "'Spirits Soft', serif" }}
            >
              "You don't need to explain your reality here."
            </p>
          </div>

          {/* Two Column Layout - Our Purpose and Our Community */}
          <div className="relative">
            {/* Mobile Layout */}
            <div className="lg:hidden space-y-12">
              {/* Our Purpose */}
              <div className="space-y-6">
                <h2
                  className="text-[#e4a483] text-xs md:text-sm tracking-[0.3em] font-medium uppercase"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  Our Purpose
                </h2>
                <p
                  className="text-[#1a441f] text-xl md:text-2xl lg:text-3xl leading-relaxed font-light"
                  style={{ fontFamily: "'Spirits Soft', serif" }}
                >
                  The Generational Wealth Society was built for those who understand that inheriting wealth is only the beginning. We exist to support the deeper work — of identity, purpose, and principled stewardship.
                </p>
                <p
                  className="text-[#2c2c2c] text-[1rem] leading-relaxed font-light"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  GWS is not a networking club. It is a sanctuary — a rare space where next-generation inheritors from around the world can be understood, not defined by their last name. Here, privilege is not performed. It is examined, questioned, and ultimately shaped into something meaningful.
                </p>
              </div>

              {/* Our Community */}
              <div className="space-y-6">
                <h2
                  className="text-[#e4a483] text-xs md:text-sm tracking-[0.3em] font-medium uppercase"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  Our Community
                </h2>
                <p
                  className="text-[#1a441f] text-xl md:text-2xl lg:text-3xl leading-relaxed font-light"
                  style={{ fontFamily: "'Spirits Soft', serif" }}
                >
                  GWS is designed primarily for second- and third-generation (and above) family members, between 21 and 40, who were born into entrepreneurial or legacy families.
                </p>
                <p
                  className="text-[#2c2c2c] text-[1rem] leading-relaxed font-light"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  Some are already active in their family's operations or investments. Some are preparing for that responsibility or building their own. Here, you are among peers from different parts of the world who share similar questions, challenges, and long-term priorities.
                </p>
              </div>
            </div>

            {/* Desktop Layout */}
            <div className="hidden lg:grid lg:grid-cols-2 gap-x-16 lg:gap-x-24 gap-y-6">
              {/* Our Purpose - Header */}
              <div>
                <h2
                  className="text-[#e4a483] text-xs md:text-sm tracking-[0.3em] font-medium uppercase mb-6"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  Our Purpose
                </h2>
              </div>

              {/* Our Community - Header */}
              <div>
                <h2
                  className="text-[#e4a483] text-xs md:text-sm tracking-[0.3em] font-medium uppercase mb-6"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  Our Community
                </h2>
              </div>

              {/* Our Purpose - First Paragraph */}
              <p
                className="text-[#1a441f] text-xl md:text-2xl lg:text-3xl leading-relaxed font-light"
                style={{ fontFamily: "'Spirits Soft', serif" }}
              >
                The Generational Wealth Society was built for those who understand that inheriting wealth is only the beginning. We exist to support the deeper work — of identity, purpose, and principled stewardship.
              </p>

              {/* Our Community - First Paragraph */}
              <p
                className="text-[#1a441f] text-xl md:text-2xl lg:text-3xl leading-relaxed font-light"
                style={{ fontFamily: "'Spirits Soft', serif" }}
              >
                GWS is designed primarily for second- and third-generation (and above) family members, between 21 and 40, who were born into entrepreneurial or legacy families.
              </p>

              {/* Our Purpose - Second Paragraph */}
              <p
                className="text-[#2c2c2c] text-[1rem] leading-relaxed font-light"
                style={{ fontFamily: "'Figtree', sans-serif" }}
              >
                GWS is not a networking club. It is a sanctuary — a rare space where next-generation inheritors from around the world can be understood, not defined by their last name. Here, privilege is not performed. It is examined, questioned, and ultimately shaped into something meaningful.
              </p>

              {/* Our Community - Second Paragraph */}
              <p
                className="text-[#2c2c2c] text-[1rem] leading-relaxed font-light"
                style={{ fontFamily: "'Figtree', sans-serif" }}
              >
                Some are already active in their family's operations or investments. Some are preparing for that responsibility or building their own. Here, you are among peers from different parts of the world who share similar questions, challenges, and long-term priorities.
              </p>
            </div>

            {/* Vertical divider */}
            <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-[#e4a483]/20" />
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutPage;
